export default "/_next/static/images/924cc13dc9e18ac0295a24c30672de86.jpg";